/**
 *     Returns a function, that, as long as it continues to be invoked, will not
 *     be triggered. The function will be called after it stops being called for
 *     N milliseconds. If `immediate` is passed, trigger the function on the
 *     leading edge, instead of the trailing.
 *
 *     // Instance Debounce with 1000 milliseconds delay
 *     const debounce = new Debounce(() => {
 *         # Put your code here
 *     }, 1000, false);
 *
 *    // Init Debounce
 *    const debouncedUpdate = debounce.call();
 *
 * @param {Function} func
 * @param {Number} wait
 * @param {Boolean} immediate
 */

export default class Debounce {
  constructor(func, wait, immediate) {
    this.func = func;
    this.wait = wait;
    this.immediate = immediate;
  }

  call() {
    let timeout;
    const self = this;
    return function() {
      const context = this, args = arguments;
      const later = function() {
        timeout = null;
        if (!self.immediate) {
          self.func.apply(context, args);
        }
      };
      const callNow = self.immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, self.wait);
      if (callNow) {
        self.func.apply(context, args);
      }
    };
  }
}
